export const COMPANY_UPDATE_STRINGS = {
    COMPANY_GENERAL: "COMPANY_GENERAL",
    COMPANY_BILLING_ITEMS: "COMPANY_BILLING_ITEMS",
    BILLING_CONFIGURATIONS: "BILLING_CONFIGURATIONS",
};
export var COMPANY_RESOURCE_TYPE;
(function (COMPANY_RESOURCE_TYPE) {
    COMPANY_RESOURCE_TYPE["SUBSCRIBER"] = "SUBSCRIBER";
})(COMPANY_RESOURCE_TYPE || (COMPANY_RESOURCE_TYPE = {}));
export var COMPANY_RESOURCE_ACCESS_TYPE;
(function (COMPANY_RESOURCE_ACCESS_TYPE) {
    COMPANY_RESOURCE_ACCESS_TYPE["OWNER"] = "OWNER";
    COMPANY_RESOURCE_ACCESS_TYPE["COLLABORATOR"] = "COLLABORATOR";
    COMPANY_RESOURCE_ACCESS_TYPE["VIEWER"] = "VIEWER";
})(COMPANY_RESOURCE_ACCESS_TYPE || (COMPANY_RESOURCE_ACCESS_TYPE = {}));
export var COMPANY_TYPE_KEY;
(function (COMPANY_TYPE_KEY) {
    COMPANY_TYPE_KEY["EMPLOYER"] = "EMPLOYER";
    COMPANY_TYPE_KEY["INSURER"] = "INSURER";
    COMPANY_TYPE_KEY["PHYSIO"] = "PHYSIO";
    COMPANY_TYPE_KEY["GP"] = "GP";
    COMPANY_TYPE_KEY["BROKER"] = "BROKER";
    COMPANY_TYPE_KEY["SOLICITOR"] = "SOLICITOR";
})(COMPANY_TYPE_KEY || (COMPANY_TYPE_KEY = {}));
//# sourceMappingURL=company.js.map